(function () {

	'use strict';
	/**
	 * @ngdoc directive
	 * @name mpaApp.ValidateDirective
	 * @description
	 * # ValidateDirective
	 * Directive in the mpaApp.
	 */
	angular
		.module('AutoPrequal')
		.service('LoadingInterceptor', ['$q', '$rootScope', '$log', function ($q, $rootScope, $log) {
			'use strict';

			var xhrCreations = 0;
			var xhrResolutions = 0;

			function isLoading() {
				return xhrResolutions < xhrCreations;
			}

			function updateStatus() {
				$rootScope.loading = isLoading();
				if (!isLoading()) {
					$rootScope.showLoader = false;
				}
			}

			return {
				request: function (config) {
					//exception for branch location
					xhrCreations++;

					if (config.url !== "/cgi-bin/common-ws/rbcServices_v1/service.cgi/branchlocator/alternate") {
						updateStatus();
					}
					if (config.url === baseUrl + "api/OOW/question" || config.url === baseUrl + "api/OOW/answer" || config.url === baseUrl + "api/submit/post" || config.url === baseUrl + "api/consent/post") {
						$rootScope.showLoader = true;
					}

					return config;
				},
				requestError: function (rejection) {
					xhrResolutions++;
					updateStatus();
					$log.error('Request error:', rejection);
					return $q.reject(rejection);
				},
				response: function (response) {
					xhrResolutions++;
					updateStatus();
					return response;
				},
				responseError: function (rejection) {
					xhrResolutions++;
					updateStatus();
					$log.error('Response error:', rejection);
					return $q.reject(rejection);
				}
			};
		}]);
})();
